<template>
    <div class="medicaid-format-selector">
        <label class="selector-label">Medicaid ID Format</label>
        <Multiselect
            :value="selectedOption"
            :options="formatOptions"
            :searchable="true"
            :allow-empty="true"
            :disabled="disabled || loadingStates"
            :loading="loadingStates"
            track-by="value"
            label="label"
            :placeholder="loadingStates ? 'Loading states...' : 'Select Medicaid ID Format'"
            @input="handleSelect"
        />
        <p v-if="formatDescription" class="format-description">{{ formatDescription }}</p>
    </div>
</template>

<script>
    import { medicaid } from '@/util/apiRequests';

    export default {
        name: 'MedicaidIdFormatSelector',
        props: {
            value: {
                type: String,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                formatOptions: [],
                loadingStates: false,
            };
        },
        computed: {
            selectedOption() {
                if (!this.value) return null;
                return this.formatOptions.find((opt) => opt.value === this.value) || null;
            },
            formatDescription() {
                if (!this.selectedOption) return null;
                return this.selectedOption.description || this.selectedOption.formatHint || null;
            },
        },
        methods: {
            handleSelect(option) {
                this.$emit('input', option ? option.value : null);
            },
            async fetchMedicaidStates() {
                this.loadingStates = true;
                try {
                    const endpoint = medicaid.getStates();
                    const response = await this.$api.get(endpoint);

                    const states = Array.isArray(response.data)
                        ? response.data
                        : Array.isArray(response.data.data)
                          ? response.data.data
                          : response.data.info || [];

                    this.formatOptions = states
                        .filter((s) => s.value)
                        .map((s) => ({
                            value: s.value,
                            label: s.label || s.name || s.value,
                            description: s.description || s.formatHint || '',
                        }));
                } catch (error) {
                    console.error('[MedicaidSelector] Failed to fetch states:', error);
                    this.formatOptions = [];
                } finally {
                    this.loadingStates = false;
                }
            },
        },
        created() {
            this.fetchMedicaidStates();
        },
    };
</script>

<style scoped>
    .medicaid-format-selector {
        max-width: 400px;
    }

    .selector-label {
        display: block;
        font-size: 1.3rem;
        font-weight: 600;
        color: #5155c3;
        margin-bottom: 10px;
    }

    .format-description {
        margin-top: 8px;
        font-size: 13px;
        color: #5155c3;
        font-weight: 500;
    }
</style>
